<template>
  <VApp id="inspire">
    <NavigationDrawer />
    <ToolBar
      :mass-text-icon="massTextIcon"
    />
    <VContent>
      <VContainer
        ref="container"
        fluid
      >
        <RouterView />
      </VContainer>
    </VContent>
    <MessageDrawer />
    <!--<v-btn-->
    <!--fab-->
    <!--bottom-->
    <!--right-->
    <!--color="pink"-->
    <!--dark-->
    <!--fixed-->
    <!--@click.stop="onNewContactDialogToggled"-->
    <!--&gt;-->
    <!--<v-icon>add</v-icon>-->
    <!--</v-btn>-->
    <!--<new-contact-dialog />-->
  </VApp>
</template>

<script>
import ToolBar from '@/components/ToolBar'
import NavigationDrawer from '@/components/NavigationDrawer'
import MessageDrawer from '@/components/MessageDrawer'

export default {
  name: 'DashboardPage',
  components: {
    ToolBar,
    NavigationDrawer,
    MessageDrawer
    // NewContactDialog
  },
  computed: {
    // TODO: mass text icon visibility should be based on route
    massTextIcon () {
      return this.$route.meta.massText
    }
  }
}
</script>

<style scoped>

</style>
